import axiosInstance from "@/lib/axios";
import { AvatarUpdateResponse, ProfileUpdatePayload, ProfileUpdateResponse } from "../types/setting.types";

export const settingApi = {
    updateProfile: async (data: ProfileUpdatePayload): Promise<ProfileUpdateResponse> => {
        const response = await axiosInstance.post<ProfileUpdateResponse>(
            '/user/profile-data-update',
            data
        );
        return response.data;
    },

    updateAvatar: async (file: File): Promise<AvatarUpdateResponse> => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await axiosInstance.post<AvatarUpdateResponse>(
            '/user/profile-picture-update',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );
        return response.data;
    },
};